const toTimestamp = (value) => new Date(value).getTime()

export const createAlertTimeIndex = (alerts) => {
  if (!Array.isArray(alerts)) return []

  return alerts
    .reduce((result, alert) => {
      const timestamp = toTimestamp(alert?.createdOn)

      if (Number.isFinite(timestamp)) {
        result.push({ timestamp, alert })
      }

      return result
    }, [])
    .sort((a, b) => a.timestamp - b.timestamp)
}

const findFirstAfter = (index, timestamp) => {
  let low = 0
  let high = index.length

  while (low < high) {
    const middle = Math.floor((low + high) / 2)

    if (index[middle].timestamp <= timestamp) low = middle + 1
    else high = middle
  }

  return low
}

const findFirstAtOrAfter = (index, timestamp) => {
  let low = 0
  let high = index.length

  while (low < high) {
    const middle = Math.floor((low + high) / 2)

    if (index[middle].timestamp < timestamp) low = middle + 1
    else high = middle
  }

  return low
}

export const getAlertsBetween = (alertTimeIndex, startTime, endTime) => {
  if (!Array.isArray(alertTimeIndex) || !alertTimeIndex.length) return []

  const startTimestamp = toTimestamp(startTime)
  const endTimestamp = toTimestamp(endTime)

  if (
    !Number.isFinite(startTimestamp) ||
    !Number.isFinite(endTimestamp) ||
    startTimestamp >= endTimestamp
  ) {
    return []
  }

  const startIndex = findFirstAfter(alertTimeIndex, startTimestamp)
  const endIndex = findFirstAtOrAfter(alertTimeIndex, endTimestamp)

  return alertTimeIndex.slice(startIndex, endIndex).map(({ alert }) => alert)
}
